export class GeocodeRequestModel {
  address: string;
  type: string;
  geocodeResponse: string;
}